<template>
    <form onsubmit="return false;" class="question">
        <div class="title" v-if="detail.title" v-html="detail.title"></div>
        <div class="item-container"  v-bind:class="{ loading: loading }">
            <div class="item">
                <div class="q-image" v-if="detail.image">
                    <img v-if="detail.imageSize == 'tall'" height="125" v-bind:src="detail.image" />
                    <img v-if="detail.imageSize == 'wide'" width="140" v-bind:src="detail.image" />
                </div>
                <div class="q-subtitle" v-if="detail.subtitle" v-html="detail.subtitle"></div>
                <h2 class="q-question" v-if="detail.question" v-html="detail.question"></h2>
                <div class="q-form">
                    <div v-if="!detail.content">
                        <slot></slot>
                    </div>
                    <div id="question-content"></div>
                </div>
            </div>
        </div>
        <div v-if="detail.paginate" class="navigation flex-center">
            <div class="page-number" v-if="pages > 1">
                <span class="current-page-number" v-html="currentQuestion"></span>
                / <span class="total-page-number" v-html="pages"></span>
            </div>
            <div class="flex-filler"></div>
            <div class="back-button" v-if="back" @click.prevent="lastQuestion">
                <span class="material-icons flip">arrow_right_alt</span> Back
            </div>
            <div @click.prevent="nextQuestion" v-bind:class="{ 'can-submit' : canSubmit }"  class="next-button" v-if="next">
                <a href="" v-bind:class="{ isLoading : loading,'red' : hasIssue }"
                   ref="nextButton" class="button pill small" v-bind:style="{ paddingRight: (success || hasIssue || pages <= 1 ? '15px' : '4px') }">
                    <div class="msg">
                        <span v-html="submitText"></span> <span v-if="!success && !hasIssue && pages > 1" class="material-icons">arrow_right_alt</span>
                    </div>
                    <div style="margin-top:-29px;" class="loader"></div>
                </a>
            </div>
        </div>
    </form>
</template>

<script>
    module.exports = {
        created: function () {
            if(this.subtitle != undefined) { this.detail.subtitle = this.subtitle; }
            if(this.question != undefined) { this.detail.question = this.question; }
            if(this.image != undefined) { this.detail.image = this.image; }
            if(this.title != undefined) { this.detail.title = this.title; }
            if(this.paginate != undefined) { this.detail.paginate = this.paginate; }
            if(this.form != undefined) { this.detail.form = this.form; }
            if(this.pageCount != undefined) { this.pages = parseFloat(this.pageCount) }
            if(this.imageSize != undefined) { this.detail.imageSize = this.imageSize }
            if(this.pages <= 1) {
                this.submitText = "Save";
            }
        },
        data:function() {
            return {
                responses : {},
                back:false,
                next:true,
                success:false,
                currentQuestion:1,
                submitText:'Next',
                hasIssue:false,
                canSubmit:false,
                loading:false,
                pages:0,
                currentSubmissionIndex:{},
                detail: {
                    subtitle:false,
                    question:false,
                    image:false,
                    imageSize:'tall',
                    title:false,
                    paginate:false,
                    form:false,
                    content:false
                }
            }
        },
        props:{
            subtitle: { type: String },
            question: { type: String },
            image: { type: String },
            title: { type: String },
            paginate: { type: String },
            form: { type: String },
            pageCount: { type: String },
            imageSize: { type: String }
        },
        methods: {
            nextQuestion:function() {
                if(this.detail.paginate && !this.loading) {
                    this.loadQuestion(this.currentQuestion + 1,'forward');
                }
            },
            lastQuestion:function() {
                if(this.detail.paginate && !this.loading) {
                    this.loadQuestion(this.currentQuestion - 1,'back');
                }
            },
            loadQuestion:function(page,direction) {
                if(this.hasIssue || this.loading) {
                    return false;
                }
                var e = this;
                e.loading = true;
                if (direction == 'back' || !this.hasErrors()) {
                    this.loadResponses();
                    $.get(e.detail.paginate, {
                        question: page,
                        responses : this.responses
                    }, function (data) {
                        if (data.status == 200) {
                            if(data.data != undefined) {
                                var q = data.data;
                                var containerWidth = parseFloat($('.item-container').css('width'));
                                if (direction == 'forward') {
                                    $('.item-container').animate({'left': -containerWidth + 'px'}, 200);
                                } else {
                                    $('.item-container').animate({'left': containerWidth + 'px'}, 200);
                                }
                                setTimeout(function () {
                                    e.loading = false;
                                    e.detail.subtitle = q.subtitle;
                                    e.detail.question = q.question;
                                    e.detail.image = q.image;
                                    e.detail.title = q.title;
                                    e.detail.content = q.content;
                                    e.back = false;
                                    e.submitText = 'Next';
                                    e.canSubmit = false;


                                    if (q.content != undefined) {
                                        $('#question-content').html('<div id="question-content-detail"></div>');
                                        var res = Vue.compile(q.content)
                                        var vm = new Vue({
                                            render: res.render,
                                            staticRenderFns: res.staticRenderFns
                                        })
                                        vm.$mount('#question-content-detail');
                                    }

                                    if (page > 1) {
                                        e.back = true;
                                    }
                                    if (q.pages != undefined) {
                                        e.pages = q.pages;
                                    }

                                    if (e.pages == page) {
                                        e.submitText = 'Submit';
                                        e.canSubmit = true;
                                    }

                                    if (q.imageSize != undefined) {
                                        e.detail.imageSize = q.imageSize;
                                    } else {
                                        e.detail.imageSize = 'tall';
                                    }
                                }, 200);
                                setTimeout(function () {
                                    $('.item-container').css('height', parseFloat($('.item-container .item').css('height')) + 'px');
                                }, 250);
                                setTimeout(function () {
                                    if (direction == 'forward') {
                                        $('.item-container').css('left', containerWidth + 'px');
                                        e.currentQuestion += 1;
                                    } else {
                                        $('.item-container').css('left', -containerWidth + 'px');
                                        e.currentQuestion -= 1;
                                    }
                                    if(q.page != undefined) {
                                        e.currentQuestion = q.page;
                                    }
                                    $('.item-container').animate({'left': '0px'}, 200);
                                    e.$positionModal();

                                }, 400);
                            } else if(data.msg != undefined) {
                                //e.success = true;
                                //e.loading = false;
                                //e.submitText = data.msg;
                                if(data.location != undefined && data.location != 'false' && data.location != '') {
                                    setTimeout(function() {
                                        document.location.href = data.location;
                                    },50);
                                }
                            }
                        } else {
                            e.error(data);
                        }
                    });
                } else {
                    e.loading = false;
                }
            },
            loadResponses:function() {
                var data = $(this.$el).serializeArray();
                var form = this;
                $(form.$el).find('input,select,textarea').each(function() {
                    if($(this).attr('name') != undefined) {
                        var name = form.getInputName($(this).attr('name'))[0];
                        if (form.responses[name] != undefined) {
                            delete form.responses[name];
                        }
                    }
                });
                if(data.length > 0) {
                    this.currentSubmissionIndex = {};
                    $.each(data,function(index,value) {
                        var name = form.getInputName(value.name);
                        var key = name[0];
                        if(name.length > 1) {
                            var subkey = name[1];
                            if(form.responses[key] == undefined) {
                                form.responses[key] = {};
                            }
                            if(name.length == 3) {
                                var nestedkey = name[2];
                                if(form.responses[key][subkey] == undefined) {
                                    form.responses[key][subkey] = {};
                                }
                                form.responses[key][subkey][nestedkey] = value.value;
                            } else {
                                form.responses[key][subkey] = value.value;
                            }
                        } else {
                            form.responses[key] = value.value;
                        }
                    });
                }
                console.log(this.responses);
            },
            getInputName: function(name) {
                var name =  name.split("[");
                var key = name[0];
                if(this.currentSubmissionIndex[key] == undefined) {
                    this.currentSubmissionIndex[key] = 0;
                } else {
                    this.currentSubmissionIndex[key] += 1;
                }
                if(name.length > 1) {
                    var subkey = name[1].substr(0,name[1].length - 1);
                    if(subkey == '') {
                        subkey =  this.currentSubmissionIndex[key];
                    }
                    if(name.length == 3) {
                        if(this.currentSubmissionIndex[subkey] == undefined) {
                            this.currentSubmissionIndex[subkey] = 0;
                        } else {
                            this.currentSubmissionIndex[subkey] += 1;
                        }
                        var nestedKey = name[2].substr(0,name[2].length - 1);
                        if(nestedKey == '') {
                            nestedKey =  this.currentSubmissionIndex[subkey];
                        }
                        return [key,subkey,nestedKey];
                    }
                    return [key,subkey];
                } else {
                    return [key];
                }
            },
            hasErrors:function() {
                var form = this;
                var e = form.$el;
                var hasErrors = false;
                $(e).find('input,select,textarea').each(function() {
                    if($(this).hasClass('required') && !$(this).is(':disabled') && $(this).is(':visible')) {
                        if($(this).val() == '') {
                            $(this).addClass('error');
                            hasErrors = true;
                        } else {
                            $(this).removeClass('error');
                        }
                    }
                });
                if($(form.$el).find('.checkbox-grid-container.required input').length > 0) {
                    var incomplete = true;
                    $(form.$el).find('.checkbox-grid-container.required input').each(function () {
                        if($(this).is(':checked')) {
                            incomplete = false;
                        }
                    });
                    if(incomplete) {
                        form.flashMessage('Select an option');
                        hasErrors = true;
                    }
                }
                return hasErrors;
            },
            error:function(data) {
                if(data.status != undefined && data.status == 204) {
                    // LOGGED OUT
                    this.flashMessage("Oops! You are not logged in.");
                } else {
                    // General error
                    if(data.msg != undefined) {
                        this.flashMessage(data.msg);
                    } else {
                        this.flashMessage("Oops! An error occured.");
                    }
                }
            },
            flashMessage:function(message,timing = 2000) {
                var form = this;
                form.loading = false;

                if(message != undefined) {
                    var holdMessage = form.submitText;
                    form.submitText = message;
                    setTimeout(function () {
                        form.submitText = holdMessage;
                    }, timing);
                }

                form.hasIssue = true;
                setTimeout(function () {
                    form.hasIssue = false;
                }, timing);

                setTimeout(function() {
                    form.canSubmit = true;
                },timing);
            }
        },
        mounted:function() {
            var e = this;
            setTimeout(function() {
                $('.item-container').css('height',  $('.item-container .item').outerHeight() + 'px');
                e.$positionModal();
            },500);
        }
    }
</script>
